import { useContext } from "react";

import { DataContext } from "@/provider/DataContextProvider";
import { portalRoutes } from "@/router/routes/portalRoutes";
import { getEntry } from "@/utils/dataContextHelpers";
import { useHasPrechargedMobileAbo } from "@/utils/tariffUtils";
import { getPreviousWizardPath } from "@/utils/wizardNavigation";

/**
 * Back-navigation target for the current wizard step, derived from basket
 * option, precharge state, and purchase-intent entry metadata.
 */
export const usePreviousWizardPath = (currentStep: number): string | null => {
  const { dataContext } = useContext(DataContext);
  const hasPrechargedMobileAbo = useHasPrechargedMobileAbo(dataContext.basket);
  const entry = getEntry(dataContext);
  const optionId =
    entry?.options?.[0]?.product?.id ?? dataContext.selectedOption?.id;

  return getPreviousWizardPath({
    currentStep,
    basePath: portalRoutes.addDevice.base,
    optionId,
    isPrecharged:
      !!dataContext.selectedOption?.precharged || hasPrechargedMobileAbo,
    wizardEntry: dataContext.wizardEntry,
  });
};
